import { render, staticRenderFns } from "./CadastroPerfil.vue?vue&type=template&id=4e11b2fc&scoped=true&"
import script from "./CadastroPerfil.vue?vue&type=script&lang=js&"
export * from "./CadastroPerfil.vue?vue&type=script&lang=js&"
import style0 from "./CadastroPerfil.vue?vue&type=style&index=0&id=4e11b2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e11b2fc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e11b2fc')) {
      api.createRecord('4e11b2fc', component.options)
    } else {
      api.reload('4e11b2fc', component.options)
    }
    module.hot.accept("./CadastroPerfil.vue?vue&type=template&id=4e11b2fc&scoped=true&", function () {
      api.rerender('4e11b2fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/EscolhaPerfil/CadastroPerfil.vue"
export default component.exports